var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.values),function(value,key){return _c('b-badge',{key:key,staticClass:"text-left mr-2 mb-2",attrs:{"variant":"info"}},[_c('small',{staticClass:"d-block"},[_vm._v(_vm._s(value.label))]),_c('span',[_vm._v(" "+_vm._s(value.value)+" ")])])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }